
define('text!templates/modules/note/note.html',[],function () { return '<div class="notes">\n    <ul class="menu-actions nav nav-pills"></ul>\n    <div id="search-member" class="search-placeholder" style="display:none;"></div>\n    <div class="alert-list"></div>\n    <div class="note-list"></div>\n    <div class="message-write message-chatbox note-write"></div>\n</div>\n';});

